import React from "react";
import { connect } from "react-redux";
import ImageContainer from "@components/imageContainer";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import DOMPurify from "isomorphic-dompurify";
import Badge from "@components/common/badge";
import { IBadge } from "@components/common/badge";
import {
  BannerContainer,
  BannerText,
  ListContainer,
  ListItem,
  ListItemIcon,
  ListItemText
} from "./styles";

export interface IBannerWithListItems extends CommonProps {
  badge: IBadge;
  listItems?: Array<{
    imgSrc: string;
    text: string;
    alt?: string;
  }>;
  showListItems?: boolean;
  text?: string;
}


const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const BannerWithListItems = (props: IBannerWithListItems) => {
  const { 
    is_visible, 
    text, 
    styles, 
    badge, 
    listItems, 
    showListItems = true
  } = props;

  if (!is_visible) return null;

  return (
    <BannerContainer styles={styles}>
      {badge?.text && (
        <Badge
        is_visible
        type={badge?.type}
        image={badge?.image?.imgSrc}
        text={badge?.text}
        styles={badge?.styles}
        textStyles={badge?.textStyles}
        />
       )} 
       {text && (
        <BannerText
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(text)
          }}
        />
       )}
        {showListItems && listItems && listItems?.length > 0 && (
        <ListContainer>
            {listItems?.map((item, index) => {
              return (
              <ListItem key={index}>
                  <ListItemIcon>
                  <ImageContainer
                      imgSrc={item.imgSrc}
                      height={16}
                      width={16}
                      alt={item.alt || `icon-${index}`}
                  />
                  </ListItemIcon>
                  <ListItemText
                  dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.text)
                  }}
                  />
              </ListItem>
              );
            })}
        </ListContainer>
        )}
    </BannerContainer>
  );
};

export default connect(mapStateToProps)(BannerWithListItems);